import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';

import { getProducts, getPriceById, createCheckoutSession, createPortalSession } from "../Services/API/stripe";
import { authJWT } from "../Services/API/auth";
import CorelifeLogo from "../Assets/CorelifeLogo.png";

export default function Subscriptions() {
    let { token } = useParams();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [customer, setCustomer] = useState();
    const [selectedProduct, setSelectedProduct] = useState({});
    const [seletedDefaultPrice, setSelectedDefaultPrice] = useState({});
    const [products, setProducts] = useState([]);
    const [open, setOpen] = React.useState(false);
    const handleProductClick = async (event, index, product) => {
        setSelectedIndex(index);
        const defaultPrice = await getPriceById(product.default_price);
        setSelectedDefaultPrice(defaultPrice.price);
        setSelectedProduct(product)
        setOpen(true);
    };
    useEffect(() => {
        async function authToken (){
            const authRes = await authJWT(token);
            setCustomer(authRes.customer)
        }
        authToken();
    }, []);
    useEffect(() => {
        async function requestProducts (){
            const res = await getProducts();
            for (const p of res.products.data){
                
                if(p.default_price){
                    const defaultPrice = await getPriceById(p.default_price);
                    if(defaultPrice.price.type === 'one_time'){
                        p.unit_amount = defaultPrice.price.unit_amount/100;
                        p.type = 'One Time'
                    } else if(defaultPrice.price.type === 'recurring'){
                        p.unit_amount = defaultPrice.price.unit_amount/100 + ` /month`;
                        p.type = 'Subscription'
                    }
                }
                
            }
            setProducts(res.products.data);

        }
        requestProducts();
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const selfManageClick = async() => {
        const portalSessionRes = await createPortalSession(customer.StripeCustomerId);
        console.log(portalSessionRes);
        window.open(portalSessionRes.session.url, "_blank", "noreferrer");
    };

    const purchaseProduct = async() => {
        let checkoutMode;
        if(seletedDefaultPrice.type === 'one_time'){
            checkoutMode = 'payment';
        }else if(seletedDefaultPrice.type === 'recurring'){
            checkoutMode = 'subscription';
        }
        const checkoutsession = await createCheckoutSession(customer.StripeCustomerId,seletedDefaultPrice.id, checkoutMode, customer.ORGID);
        window.open(checkoutsession.session.url, "_blank", "noreferrer");
    };

  return (
    
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Purchase following product?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Product Name: {selectedProduct.name}
                    <br></br>
                    Price Amount: ${seletedDefaultPrice.unit_amount/100}
                    <br></br>
                    Currency: {seletedDefaultPrice.currency}
                    <br></br>
                    Price Type: {seletedDefaultPrice.type}
                </DialogContentText>
                {
                    seletedDefaultPrice.recurring && (
                        <DialogContentText id="alert-dialog-description">
                            Recurring Interval: {seletedDefaultPrice.recurring.interval}
                        </DialogContentText>
                    )
                }
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={purchaseProduct} autoFocus>
                Purchase
            </Button>
            </DialogActions>
        </Dialog>
        <Box component="img" src={CorelifeLogo} sx={{  width: "150px", margin: "20px 0px 10px 30px", display: { sm: 'block', xs: 'none' } }}>
        </Box>
        
        <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
                <Typography sx={{ mt: 4, mb: 2, ml:10, mr:10 }} variant="h6" component="div">
                At CoreLife, we know that treating obesity requires more than focusing on body weight. 
                People struggling with obesity are often facing a number of related chronic conditions 
                that limit their success with traditional diet and exercise programs.
                <br></br>
                <br></br>
                CoreLife is different. We work with each patient to identify the root causes of weight gain 
                and develop a personalized plan that combines medical treatment, dietary guidance, 
                physical fitness, and behavioral health.
                Our compassionate team will provide encouragement and accountability, 
                empowering you with the tools and knowledge you need for lifelong success. 
                Your CoreLife membership gives you access to all this and more.

                </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
                <Typography sx={{ mt: 4, mb: 2, ml:10, mr:10 }} variant="h5" component="div">
                    Choose a Plan
                </Typography>
            </Grid>
            <Grid item xs={2} md={2}>
            </Grid>
            <Grid item xs={2} md={2}>
            </Grid>
            <Grid item xs={2} md={2}>
            {
                customer && (
                    <Box sx={{ ml:3, mr:3, mt:3}}>
                        <Button variant="contained" onClick={selfManageClick}>My Payment Account</Button>
                    </Box>
                )
            }
            </Grid>
        </Grid>
   
      <Grid container spacing={2}>
            {
                products.map((product, index) =>product.default_price && (
                    <Grid item xs={6} md={2}>
                        <Paper sx={{ ml:3, mr:3}} elevation={5}>
                            <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h6" component="div">
                                {product.name}
                            </Typography>
                            <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h7" component="div">
                               {product.type}
                            </Typography>
                            <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h8" component="div">
                               ${product.unit_amount}
                            </Typography>
                            
                            <Typography sx={{ pt:3,pl:2,  }} variant="body2" component="div">
                                Up to 10 users, Email Support, Placeholder
                            </Typography>
                            <Box sx={{ pb:5, pt:5, textAlign:"center" }} >
                            <Button 
                                variant="contained"
                                onClick={(event) => handleProductClick(event, index, product)}>
                                Purchase
                            </Button>
                            </Box>
                            
                        </Paper>
                    </Grid>
                ))
            }   
      </Grid>
     

      
      
    </Box>
  );
}
